import { createContext } from 'react';

import { AppConfigErrorScreen } from '../features/app-config/app-config-error-screen/app-config-error-screen';
import { useShouldUseCdmMode } from '../hooks/use-should-use-cdm-mode';
import { PageLoader } from '../pages/page-loader/page-loader';

import { CdmProviders } from './cdm-providers';
import { ClassicProviders } from './classic-providers';

export interface AppProvidersSwitcherContextInterface {
  PageLoader: typeof PageLoader;
  CdmProviders: typeof CdmProviders;
  ClassicProviders: typeof ClassicProviders;
  useShouldUseCdmMode: typeof useShouldUseCdmMode;
  AppConfigErrorScreen: typeof AppConfigErrorScreen;
}

const defaultValue: AppProvidersSwitcherContextInterface = {
  useShouldUseCdmMode,
  PageLoader,
  CdmProviders,
  ClassicProviders,
  AppConfigErrorScreen,
};

export const AppProvidersSwitcherContext =
  createContext<AppProvidersSwitcherContextInterface>(defaultValue);
